import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
export function DescriptionSkeleton() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Skeleton, { skeletonProps: {
                height: 24,
                width: '50%',
            }, wrapperProps: {
                mbS: 4,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 40,
            }, wrapperProps: {
                mbS: 16,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 16,
                count: 3,
            }, wrapperProps: {
                mbS: 24,
                mbL: 32,
            } })));
}
